export default __webpack_public_path__ + "static/media/D_Home_R.e528d29d.jpg";